import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { AttachmentsCellProps } from '../../../../../../../core/types/coreTypes';
import usePermission from '../../../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../../../core/enums/dictionariesEnums';
import { useAppDispatch } from '../../../../../../../store/hooks';
import ConfirmationModal from '../../../../../../../core/components/confirmation-modal/ConfirmationModal';
import {
  deleteEmployeeAttachmentThunk,
  getEmployeeAttachmentByIdThunk,
} from '../../../../../../../store/thunks/employee/employeeAttachmentsThunks';
import AttachmentsRow from '../../../../../../../common/components/attachments-table/AttachmentsRow';

const EmployeeAttachmentsCell:React.FC<AttachmentsCellProps> = ({
  attach,
  openEditModal,
  checked,
  checkRow,
}) => {
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const [isModal, setModal] = useState<boolean>(false);
  const allowedManage = usePermission(PermissionEnum.EmployeeEditFields);
  const actions = [
    {
      label: 'Edit comment',
      icon: <FontAwesomeIcon icon={faEdit} />,
      key: 'edit-comment',
      onClick: () => openEditModal(),
    },
    {
      label: 'Delete file',
      key: 'delete-file',
      icon: <FontAwesomeIcon icon={faTrashAlt} />,
      onClick: () => setModal(true),
    },
  ];

  return (
    <>
      <ConfirmationModal
        isVisible={isModal}
        onCancel={() => setModal(false)}
        confirmHandler={() => id && dispatch(deleteEmployeeAttachmentThunk({
          id: attach.id,
          employeeId: +id,
          closeModal: () => setModal(false),
        }))}
      />
      <AttachmentsRow
        allowedManage={!!allowedManage}
        attachment={attach}
        checked={checked}
        checkRows={checkRow}
        onClick={(attachId) => id && dispatch(getEmployeeAttachmentByIdThunk({
          id: attachId,
          employeeId: +id,
        }))}
        actions={actions}
      />
    </>
  );
};

export default EmployeeAttachmentsCell;
